// src/components/Services/WebDevelopmentServices.js
import React from 'react';
import './WebDevelopmentServices.css';

const WebDevelopmentServices = () => {
  const services = [
    {
      title: 'Custom Website Development',
      description:
        'I build custom, responsive websites tailored to your business needs, ensuring seamless user experiences and modern designs. My expertise includes React, JavaScript, and HTML/CSS for high-performance web solutions.',
      icon: '🖥️', // Desktop icon
    },
    {
      title: 'E-commerce Solutions',
      description:
        'I create secure and scalable e-commerce platforms with features like product listings, payment gateways, and user-friendly interfaces. Boost your online sales with a custom-built store optimized for conversions.',
      icon: '🛒', // Shopping cart icon
    },
    {
      title: 'Website Optimization & SEO',
      description:
        'I optimize websites for speed, performance, and search engine rankings. From on-page SEO to technical enhancements, I ensure your site is fast, accessible, and visible to your target audience.',
      icon: '🚀', // Rocket icon
    },
  ];

  return (
    <div className="webdev-services">
      <h2 className="webdev-services-title">Web Development Services</h2>
      <div className="webdev-services-grid">
        {services.map((service, index) => (
          <div key={index} className="webdev-service-card">
            <div className="webdev-service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebDevelopmentServices;